export type BrokerNerdsBarkerCoreEnumsListingDisclosure = (typeof BrokerNerdsBarkerCoreEnumsListingDisclosure)[keyof typeof BrokerNerdsBarkerCoreEnumsListingDisclosure];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokerNerdsBarkerCoreEnumsListingDisclosure = {
  LimitedObstructedView: 'LimitedObstructedView',
  Accessibility: 'Accessibility',
  StandingRoomOnly: 'StandingRoomOnly',
  ResaleRestricted: 'ResaleRestricted',
  FanListing: 'FanListing',
  TevoArbitrage: 'TevoArbitrage',
} as const;
